import { IActionsInformePensiones } from "@interfaces/actions-informe-pensiones.interface";
import { IRightColumnData } from "../interfaces/right-column-data.interface";
import { URL_BENEFICIARIOS, URL_CAMBIO_FONDOS, URL_CERTIFICADOS, URL_PERFIL_RIESGO } from "./url.constant";

export const CARD_INFORME_PENSIONES: IActionsInformePensiones[] = [
    {
        title: 'Cambia de fondo',
        description: 'Con el informe sabrás si estás o no en el fondo que se ajusta a tu perfil, con esto podrás decidir si cambiarte o permanecer en el mismo.',
        nameButton: 'Ir a Cambio de Fondos',
        icon: `../assets/icons/cambio-fondo-informe.svg`,
        link: URL_CAMBIO_FONDOS
    },
    {
        title: 'Actualiza tu Perfil de Riesgo',
        description: 'Si aún no has calculado tu Perfil de Riesgo o piensas que ya no te representa, vuelve a calcularlo, con eso tendrás una sugerencia de fondos más acertada.',
        nameButton: 'Ir a Perfil de Riesgo',
        icon: `../assets/icons/perfil-riesgo-informe.svg`,
        link: URL_PERFIL_RIESGO
    },
    {
        title: 'Inscribe a tus beneficiarios',
        description: 'Mantener actualizados a tus beneficiarios legales por sobrevivencia, te permitirá tener una estimación de pensión mas ajustada a la realidad​.',
        nameButton: 'Ir a Beneficiarios',
        icon: `../assets/icons/beneficiarios-informe.svg`,
        link: URL_BENEFICIARIOS
    },
    {
        title: 'Comprueba el pago de tus cotizaciones',
        description: 'Revisa tu certificado de pago de cotizaciones y comprueba si están al día, esto te ayudará a tomar decisiones sobre tu futuro​.',
        nameButton: 'Ir a Certificados',
        icon: `../assets/icons/certificados-informe.svg`,
        link: URL_CERTIFICADOS
    }
];

export const REPORTE_PERIODOS_INFORME_PENSION = "reporte-periodos-informe-pension";

export const RIGHT_COLUMN_DATA_REFORMA: IRightColumnData[] = [
  {
    sectionTitle: 'Revisa',
    sections: [
      {
        title: 'Descarga tu informe',
        element: 'statusElement',
        active: true,
      },
      {
        title: '¿Qué es el Informe de Pensiones Personalizado?',
        element: 'statusElement1',
      },
      {
        title: '¿Qué puedes hacer con tu informe?',
        element: 'statusElement2',
      },
    ],
  },
];